import * as React from 'react';
import {SFC} from 'react';
import {
    AuthSignUpForm as SignUpForm,
    IAuthSignUpFormButtonProps,
    SIGNUP_FORM_DATA,
} from '../sign-up-form/sign-up-form';
import {IAuthSignUpFormContainerConnected, IAuthSignUpFormContainerActions} from './types';

export interface IAuthSignUpFormContainerProps extends IAuthSignUpFormContainerConnected, IAuthSignUpFormContainerActions {
  socialAuthEnabled?: boolean;
  renderButton?: (props: IAuthSignUpFormButtonProps) => void;
}

export const AuthSignUpFormContainer: SFC<IAuthSignUpFormContainerProps> = ({register, ...props}) => (
  <SignUpForm formData={SIGNUP_FORM_DATA} onSend={register} {...props} />
);
